import type { SxProps, Theme } from '@mui/material';

export const howItWorksTitleSx: SxProps<Theme> = {
  textAlign: 'center',
};

export const howItWorksGridSx: SxProps<Theme> = {
  justifyContent: 'center',
};

export const howItWorksStepCardSx: SxProps<Theme> = {
  p: 2,
  borderRadius: 1,
  backgroundColor: 'background.paper',
  opacity: 0.7,
};

export const howItWorksStepBadgeSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 40,
  height: 40,
  borderRadius: '50%',
  backgroundColor: 'primary.main',
  color: 'background.default',
  fontWeight: 700,
  fontSize: '1.2rem',
};

export const howItWorksStepTitleSx: SxProps<Theme> = {
  fontWeight: 600,
};

export const howItWorksStepDescriptionSx: SxProps<Theme> = {
  opacity: 0.8,
};
